export default {"src":"/_next/static/media/glamsquad-logo.43266eff.svg","height":38,"width":278,"blurWidth":0,"blurHeight":0};